var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _g2, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUndrawLoading3Kqt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800.292,
    height: 680.201,
    viewBox: "0 0 800.292 680.201",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-445.17 -153)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.872,0H223.4c9.871,0,17.872,6.251,17.872,13.963V30.543c0,7.711-8,13.963-17.872,13.963H17.872C8,44.506,0,38.255,0,30.543V13.963C0,6.251,8,0,17.872,0Z",
    transform: "translate(696.307 218.358)",
    fill: "#f2f2f2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(454.089 337.363)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.497,
    height: 36.242,
    transform: "translate(337.978 433.438)",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.2,598.367h58.45a33.713,33.713,0,0,0,14.519-3.308l10.776-5.18a6.471,6.471,0,0,0-1.078-12.069l-22.23-6.151-38.031-19.99-.028.144c-.711,3.6-1.813,9.044-1.953,9.374-3.9,4.468-7.907,6.527-11.908,6.121-6.98-.708-11.62-8.767-11.666-8.849l-.035-.062-.071.007a4.629,4.629,0,0,0-3.593,1.959c-1.592,2.4-.621,6.1-.461,6.656-1.907,1.866-2.763,12.285-2.829,13.126-2.757,2.922-4.067,5.732-3.894,8.351.152,2.289,1.421,4.415,3.773,6.319a16.323,16.323,0,0,0,10.261,3.552Z",
    transform: "translate(105.469 -103.673)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.437,201.656a37.847,37.847,0,1,1,49.186,36.117l-7.316,48.353-37.3-31.082s8.057-10.263,12.379-21.836a37.806,37.806,0,0,1-16.95-31.552Z",
    transform: "translate(-489.648 -149.056)",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.15,236.869l53.268,2.557,6.36,14.311s61.683,27.4,65.194,54.063c0,0,15.916,44.391,50.883,42.932s-68.374,100.176-68.374,100.176L423.945,315.751l-3.975-62.557,3.18-16.325Z",
    transform: "translate(-395.839 -140.507)",
    fill: "#b1b1b1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.606,417.683l21.592-2.446c-5.5,11.672-3.574,38.928.369,66.126,5.205,35.823,13.94,101.715,13.94,101.715l36.571-9.495V394.56c0-23.881-69.042-34.738-120.693-39.52-30.852-2.848-55.5-3.541-55.5-3.541l-71.489,86.01Z",
    transform: "translate(-157.696 -127.095)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 27.497,
    height: 36.242,
    transform: "translate(258.716 446.922) rotate(-145.769)",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.132,545.4c1.329-2.256,3.988-3.842,7.919-4.7.525-.659,7.093-8.791,9.718-9.271.178-.548,1.452-4.144,4.122-5.239a4.168,4.168,0,0,1,2.714-.146,6,6,0,0,1,1.363.548l.067.033-.011.067c-.011.1-.7,9.372,4.669,13.885,3.083,2.58,7.551,3.139,13.292,1.642.3-.2,4.267-4.077,6.881-6.657l.112-.1.212.391,19.983,37.532,14.912,17.593a6.463,6.463,0,0,1-5.9,10.578L402.37,599.78a33.832,33.832,0,0,1-13.862-5.428l-48.333-32.885a16.348,16.348,0,0,1-6.478-8.713C332.825,549.861,332.97,547.393,334.132,545.4Z",
    transform: "translate(-114.391 -106.69)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.354,444.312c-21.982,36.459-44.211,95.918-44.211,95.918l6,2.145,26.753,9.562,2.826,1.016,30.6-44.96c17.581-25.847,38.492-56.587,50.511-74.236V421.19c0-23.881-69.042-34.738-120.693-39.52l69.635,36.671C353.243,422.2,345.815,431.924,338.354,444.312Z",
    transform: "translate(-55.558 -123.564)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.734,319.584h0a29.653,29.653,0,0,1,46.485.815l91.447,119.715,145.756-16.762a26.25,26.25,0,0,1,29.172,24.065h0a26.25,26.25,0,0,1-22.437,28L452.008,499.446A56.982,56.982,0,0,1,394.6,471.62L326,353.27a29.653,29.653,0,0,1,2.735-33.686Z",
    transform: "translate(-322 -132.097)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20.671,
    height: 162.854,
    transform: "translate(257.874 331.867)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 20.671,
    height: 162.854,
    transform: "translate(116.014 331.867)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.506,270.983s5.918,14.5,24.391,10.184l37.472-8.761s-51.527-68.306-36.332-63.073,40.208-39.966,40.208-39.966l15.182,16.419s22.006-15.18-10.594-29.675c0,0-38.668-16.427-68.888,7.448s-1.441,107.424-1.441,107.424h0Z",
    transform: "translate(-507.516 -150.601)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M570.565,239.834a16.739,16.739,0,1,0,0-33.478v2.234a14.492,14.492,0,1,1-5.706,1.165l-.879-2.053a16.741,16.741,0,0,0,6.585,32.131Z",
    transform: "translate(-526.584 -144.077)",
    fill: "#b1b1b1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.329,340.706l-35.151,15.842,9.249,20.524,35.152-15.842a23.628,23.628,0,0,0,18.249-.816c10.957-4.938,16.527-16.292,12.44-25.36s-16.282-12.416-27.239-7.478a23.629,23.629,0,0,0-12.7,13.131Z",
    transform: "translate(-210.389 -130.161)",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.685,286.135l28.622,82.685,66.784-20.671,12.721,34.982-99.036,27.148L423.589,303.3",
    transform: "translate(-376.615 -134.743)",
    fill: "#b1b1b1"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0,1.234H800.292V-1H0Z",
    transform: "translate(445.17 831.967)",
    fill: "#e6e6e6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M354.693,550.642c0-5.8,1.949-10.513,4.341-10.524h180.26c2.4.01,4.341,4.72,4.355,10.524V789.529a2.169,2.169,0,0,0,1.958,2.158q2.626.252,5.253.469c.044,0,.087.01.13.01.953.087,1.906.152,2.858.227h.011q.735-1.359,1.454-2.742a2.178,2.178,0,0,0,.247-1.006V536.989c0-1.6-.065-3.215-.174-4.807a61.639,61.639,0,0,0-.812-6.518c-1.829-10.058-5.966-16.868-10.665-16.89H354.433a5.071,5.071,0,0,0-1.993.422,7.767,7.767,0,0,0-2.458,1.722,15.243,15.243,0,0,0-2.414,3.3c-2.317,4.082-3.973,10.167-4.558,17.244,0,.065-.01.13-.01.2-.152,1.754-.227,3.54-.217,5.327l-.152,23.2-.1,13.837-.293,43.416-.108,15.415-.476,158.291h0a2.165,2.165,0,0,0,2.165,2.165h8.709a2.165,2.165,0,0,0,2.165-2.165Z",
    transform: "translate(550.986 38.77)",
    fill: "#e6e6e6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M216.883,324.518l12.541,55.169,8.012,8.776h5.78L219.39,288.155,218.212,305.2v.012Z",
    transform: "translate(816.18 158.66)",
    fill: "#090814"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M372.68,501.442l73.559-.466,6.532-.044,4.656-.032,5.424-.032h.044a2.993,2.993,0,0,1,2.1.867l9.159,9.16a2.362,2.362,0,0,1,.487.7,1.054,1.054,0,0,1,.141.238,3.058,3.058,0,0,1-2.75,4.267H376.74a3.032,3.032,0,0,1-2.729-1.732l-.747-1.624-1.537-3.3-1.742-3.725a2.968,2.968,0,0,1-.281-1.267,3.015,3.015,0,0,1,2.978-3Z",
    transform: "translate(600.039 38.118)",
    fill: "#090814"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M369.7,511.912l.752,1.63a3.031,3.031,0,0,0,2.721,1.73h95.3a3.048,3.048,0,0,0,2.746-4.267.906.906,0,0,0-.138-.238Z",
    transform: "translate(603.602 38.936)",
    opacity: 0.17,
    style: {
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.883,305.2v.012l20.4,83.258h4.6L218.061,288.155Z",
    transform: "translate(817.51 158.66)",
    opacity: 0.17,
    style: {
      isolation: "isolate"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M375.215,464.563l28.876-219.691a3.135,3.135,0,0,1,1.191-2.079l19.878-24.881,1.786-1.375a3.171,3.171,0,0,1,2.317-.617l2.988.4a3.135,3.135,0,0,1,2.707,3.508h0L405.033,447.456v.01L403.2,461.39l-2.177,16.533v.022l-3.378,25.725a3.066,3.066,0,0,1-1.353,2.187,3.111,3.111,0,0,1-2.526.455l-1.9-.476a3.182,3.182,0,0,1-1.8-1.234l-.845-1.2-.39-.563-13.079-36.055A3.114,3.114,0,0,1,375.215,464.563Z",
    transform: "translate(634.145 14.55)",
    fill: "#090814"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M411.516,217.913,375.192,502.84l.395.557.841,1.2a3.173,3.173,0,0,0,1.8,1.235l1.9.477a3.146,3.146,0,0,0,3.876-2.64l37.3-283.837a3.135,3.135,0,0,0-2.7-3.517l-3-.394a3.091,3.091,0,0,0-2.307.62Z",
    transform: "translate(647.795 14.55)",
    fill: "#090814",
    opacity: 0.17,
    style: {
      isolation: "isolate"
    }
  }), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M260.137,97.7l-19.276,27.513L217.951,299.53l12.421,24.641Z",
    transform: "translate(798.101 142.912)",
    fill: "#b1b1b1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(732.051 232.639)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.819,0H161.966a7.819,7.819,0,1,1,0,15.638H7.819A7.819,7.819,0,0,1,7.819,0Z",
    fill: "#b1b1b1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0H32.393a7.819,7.819,0,1,1,0,15.638H0Z",
    transform: "translate(129.573)",
    fill: "#090814"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6,43.192A20.6,20.6,0,0,1,22.6,2a2.06,2.06,0,0,1,0,4.119A16.477,16.477,0,1,0,39.073,22.6a2.06,2.06,0,1,1,4.119,0A20.619,20.619,0,0,1,22.6,43.192Z",
    transform: "translate(794.348 151)",
    fill: "#b1b1b1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawLoading3Kqt);
export default __webpack_public_path__ + "static/media/undraw_loading_3kqt.b1bd80f8ca374a1472f92764ebfdda58.svg";
export { ForwardRef as ReactComponent };